import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { CookieBanner } from "./components/CookieBanner";
import LandingPage from "./pages/LandingPage";
import Privacy from "./pages/Privacy";
import CookiesPage from "./pages/Cookies";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App font-body antialiased">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookies" element={<CookiesPage />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
          <CookieBanner />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
